import type { ReactNode } from 'react';

interface IconActionProps {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  danger?: boolean;
  /** When true, renders without border/background (like a row-action icon in dense tables). */
  bare?: boolean;
}

/**
 * Square icon-only button used across admin tables. Sizing/breakpoints live in
 * globals.css under .icon-action so we keep one shared touch target everywhere.
 */
export function IconAction({ icon, label, onClick, disabled, danger, bare }: IconActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      className="icon-action"
      style={{
        border: bare ? 'none' : '1px solid rgba(15,30,61,.12)',
        background: bare ? 'transparent' : '#fff',
        color: disabled ? '#c5cad4' : danger ? '#d0463c' : '#5b6578',
        opacity: disabled ? 0.6 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      {icon}
    </button>
  );
}
